<template>
	<q-layout view="hhh lpr fff">
		<q-header class="bg-transparent absolute-top-left absolute-top-right">
			<q-toolbar class="header-toolbar">
				<q-toolbar-title>
					<img src="https://cdn.greenpeace.fr/images/logos/greenpeace-black.svg" class="header-logo"/>
				</q-toolbar-title>

			</q-toolbar>
		</q-header>

		<q-page-container>
			<q-page>
				<home-screen @click="onAction"/>

				<actions-screen ref="action"
					:counter="counter"
					:default="tab"
					@action="onActionDone($event)"
					@select="selectAction($event)"
				/>

			</q-page>
		</q-page-container>

		<q-footer class="bg-gris text-white footer">
			<q-toolbar>
				<q-space/>
				<q-btn
				flat stretch
				type="a"
				label="Mentions légales"
				href="https://www.greenpeace.fr/mentions-legales/"
				/>
				<q-btn
				flat stretch
				type="a"
				label="Contact"
				href="https://www.greenpeace.fr/contact/"
				/>

	  			<q-space/>
				<img src="https://cdn.greenpeace.fr/images/logos/greenpeace-white.svg" class="footer-logo"/>
			</q-toolbar>
		</q-footer>

		<q-dialog v-model="modal">
			<q-card class="confirm-modal">
				<q-card-section class="row items-center">
					<q-space />
					<q-btn icon="close" flat round dense v-close-popup />
				</q-card-section>

				<q-card-section class="text-center modal-content">
					<div class="title">
						<em>
							Merci ! 
						</em>
					</div>

					<p>
						Vous avez rappelé au gouvernement ses engagements et dénoncé le décalage avec ses actes.
					</p>

					<p>
						Vous voulez vous mobiliser encore plus contre la déforestation importée&nbsp;? Rejoignez le mouvement pour être au courant des suites de cette action&nbsp;!
					</p>


					<div class="q-mt-lg q-pt-lg">
						<q-input filled v-model="email" label="Votre adresse e-mail" />
					</div>

					<div>
						<q-btn class="modal-btn btn-main" label="Je rejoins le mouvement" @click="subscribe"/>
					</div>

					<p class="rgpd q-pb-md">
						En cliquant sur "Je rejoins le mouvement", vous acceptez de recevoir des communications et des formes d'engagement de la part de Greenpeace via les coordonnées collectées dans le formulaire. Vos données personnelles collectées resteront strictement confidentielles. Elles ne seront ni vendues ni échangées conformément à nos mentions légales. L’exercice de vos droits, dont la désinscription, est possible à tout moment, voir notre page "<a href="https://www.greenpeace.fr/mentions-legales/droits-des-personnes/" target="_blank">Droit des Personnes</a>".
					</p>

					<share-items class="modal-share"/>

				</q-card-section>
			</q-card>
		</q-dialog>

		<Ticker v-if="version === 3"/>
	</q-layout>
</template>

<script>


import HomeScreen from '../components/HomeScreen.vue'
import ActionsScreen from '../components/ActionsScreen.vue'
import ShareItems from "../components/ShareItems.vue"
import Ticker from "../components/Ticker.vue"


import axios from 'axios'
import { scroll } from 'quasar'
const { getScrollTarget, setScrollPosition } = scroll


export default {
	name: 'Chouette',
	components: {
		HomeScreen,
		ActionsScreen,
		ShareItems,
		Ticker,
	},
	mounted() {
		this.$trackPage(location.href, document.title)

/*
// 20210511 : Fermeture de la page, on ne retrouve plus le nombre d'actions effectées.
		axios.get('./api')
			.then( (r) => {
				if (r.data) {
					const counter = parseInt(r.data, 10)
					if (!isNaN(counter)) {
						this.counter = counter
					}
				}
			})
			.catch( (e) => console.log('error', e))
*/

		if (location.hash.length > 1) {
			const ancre = location.hash.substr(1)
			switch (ancre) {
				case 'mail':
				case 'rs':
				case 'telephone':
				case 'carte':
				case 'soutien':
				case 'deploy':
				case 'undo':
					this.$nextTick( () => {
						this.tab = ancre
					})
					break;
			}
		}
	},
	methods: {

		onActionDone(what) {
			this.modal = true
		},
		onAction() {
			this.$trackEvent("click", "bouton je veux agir")
			this.scrollTo('action')
		},
		selectAction(el) {
			this.$nextTick( () => this.doScroll(el))
		},
		scrollTo(id) {
			const el = this.$refs[id].$el
			this.doScroll(el)
		},
		doScroll(el) {
			const target = getScrollTarget(el)
			const offset = el.offsetTop
			const duration = 500
			setScrollPosition(target, offset, duration)
		},

		subscribe() {
			const email = this.email.trim()
			if (email.length) {
				axios.get('https://action.greenpeace.fr/ens/authenticate')
					.then( (r) => {
						if (r.data) {
							const token = r.data.token

							axios.post('https://www.e-activist.com/ens/service/page/'+this.en_page_id+'/process', this.createSubscriber(email), {
								headers: {
									"Content-Type": "application/json",
									"ens-auth-token": token
								}
							})
							.then( (r) => this.modal = false)
							.catch( (e) => alert("Erreur lors de l'envoi :\n" + e.response.data.message) )
						}
					})
			}
		},
		getParam(name) {
			name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
			const regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
			const results = regex.exec(location.search)
			return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
		},
		createSubscriber(email) {
			const data = {
        		supporter: {
            		email: email,

        			questions: {
                		email_ok: "Y"
            		}
        		}
			}

			const utm_source = this.getParam('utm_source')
			const utm_medium = this.getParam('utm_medium')
 			const utm_campaign = this.getParam('utm_campaign')
	 		const utm_content = this.getParam('utm_content')
 			const utm_term = this.getParam('utm_term')

			if (utm_source) data.txn1 = utm_source
			if (utm_medium) data.txn2 = utm_medium
			if (utm_campaign) data.txn3 = utm_campaign
			if (utm_content) data.txn4 = utm_content
			if (utm_term) data.txn5 = utm_term

			return data
		}

	},
	data() {
		return {
			version: parseInt(process.env.VUE_APP_V, 10),
			watchTab: true,
			tab: "",
			email: "",
			en_page_id: 50534,
			counter: 0,
			modal: false,
		}
	},

}

</script>

